// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

export default (doc, pageIdx, rotation, ignoreCurrent=false) => {

    if (!doc || !doc.words) return;

    const words = [ ...doc.words ];
    if (!words || !words.length) return;

    // When first loading a page, we want to ignore the current rotation value
    const currentRot = (doc.rotations[pageIdx] && !ignoreCurrent) ? doc.rotations[pageIdx] : 0;
    const turns = Math.round((rotation - currentRot) / 90) % 4;

    for (const [ wordIdx, word ] of words.entries()) {

        // eslint-disable-next-line
        if (word.page != pageIdx)
            continue;

        const angle = ((word.angle ? word.angle : 0) - rotation);

        const x = word.x;
        const y = word.y;
        const w = word.width;
        const h = word.height;

        if (turns === 3 || turns === -1) { // 90 deg counterclockwise
            words[wordIdx].x = y;
            words[wordIdx].y = 1 - x - w;
            words[wordIdx].width = h;
            words[wordIdx].height = w;
        }

        else if (turns === 2 || turns === -2) { // 180 deg clockwise
            words[wordIdx].x = 1 - x - w;
            words[wordIdx].y = 1 - y - h;
        }

        else if (turns === 1 || turns === -3) { // 90 deg clockwise
            words[wordIdx].x = 1 - y - h;
            words[wordIdx].y = x;
            words[wordIdx].width = h;
            words[wordIdx].height = w;
        }

        // Dont change angle during init
        words[wordIdx].angle = angle;
    }

    return {
        ...doc,
        words,
        rotations: {
            ...doc.rotations,
            [pageIdx]: rotation
        }
    };

}